import { ExactScopeName, useHasScope } from './use-has-scope'

export function useIsHighLevelUser() {
  const isSuperUser = useHasScope(ExactScopeName.superUser)
  const isAccountManager = useHasScope(ExactScopeName.accountManager)
  return isSuperUser || isAccountManager
}
